import { Injectable, Provider } from '@angular/core'

import { RealtimeClient } from '@ti/core/realtime'

@Injectable()
export class TiRealtimeClient extends RealtimeClient {
  protected override fetchRealtimeToken() {
    return this.api.ti.user.getRealtimeToken()
  }
}

export const provideTiRealtimeClient = (): Provider[] => {
  return [{ provide: RealtimeClient, useClass: TiRealtimeClient }]
}
